import classNames from 'classnames';
import React from 'react';
import styles from './styles.sass';

type Props = {
  direction: 'up' | 'down' | 'left' | 'right';
  className?: string;
};

export const Chevron = ({ direction, className }: Props) => {
  return (
    <span
      className={classNames(styles.chevron, {
        // @ts-ignore
        [styles[direction]]: true,
        // @ts-ignore
        [className]: className,
      })}
    />
  );
};
